/*
  Contact page -> HubSpot Help Desk.

  The form GUID configured on the section carries TICKET.subject and TICKET.content
  fields, so a submission to it opens a Help Desk ticket directly. That is what the
  old WordPress contact page did via an embedded HubSpot form, and what the Shopify
  rebuild lost: the native Shopify form only ever produced a Collected-Forms contact,
  and collected forms never create tickets.

  HubSpot renders the form inside an iframe, which inherits none of the storefront's
  CSS, so the field styling and the two brand @font-face rules are injected into the
  iframe document. If HubSpot changes its markup the injection stops matching and the
  form falls back to HubSpot's own styling — it never breaks the submission.

  Target layout:
      First name | Last name
      Email                     (full width)
      Comment                   (full width)
      Send
*/
(function () {
  var cfg = window.CAROL_CONTACT_HUBSPOT || {};
  var PORTAL = (cfg.portalId || '').trim();
  var GUID = (cfg.formId || '').trim();
  var REGION = (cfg.region || 'na1').trim();
  var FONTS = cfg.fonts || {};
  var TARGET = '#carol-hs-contact';

  // Fields the form defines but the page does not want. Hiding alone is not enough:
  // HubSpot geo-fills Country, and a hidden field still submits. They are cleared and
  // disabled too, because disabled controls are excluded from serialisation. The real
  // fix is to delete these from the form in HubSpot; this only stops the bad data.
  var DROPPED = ['country', 'message', 'TICKET.subject'];

  var host = document.querySelector(TARGET);
  if (!host) return;
  if (!PORTAL || !GUID) {
    console.warn('[carol-contact] No HubSpot portal/form configured; embed skipped.');
    return;
  }

  function css() {
    return [
      FONTS.roobert ? '@font-face{font-family:"Roobert Regular";src:url("' + FONTS.roobert + '") format("woff2");font-weight:100 900;font-style:normal;font-display:swap}' : '',
      FONTS.pitch ? '@font-face{font-family:"Pitch Sans Semibold";src:url("' + FONTS.pitch + '") format("woff2");font-weight:600;font-style:normal;font-display:swap}' : '',
      'html,body{margin:0;padding:0;background:transparent;overflow:hidden}',
      '.hs-form{font-family:"Roobert Regular",Inter,Arial,sans-serif}',

      '.hs_country,.hs_message,.hs_TICKET\\.subject{display:none!important}',

      // HubSpot groups fields into <fieldset class="form-columns-N">. First/Last sit in
      // a 2-column fieldset and share a row; Email and Comment each fill their own.
      // A flex basis with wrap is used rather than a media query, because the iframe
      // does not reliably report a usable viewport width.
      'form.hs-form fieldset{max-width:none!important;display:flex;flex-wrap:wrap;gap:0 18px}',
      'form.hs-form fieldset > .hs-form-field{flex:1 1 220px;min-width:0}',
      'form.hs-form fieldset > .hs_email,form.hs-form fieldset > .hs_TICKET\\.content{flex:1 1 100%}',
      '.hs-form-field{margin:0 0 18px}',

      // The label is the block; the required asterisk inside it must stay inline or it
      // drops to its own line and pushes the input out of alignment with its neighbour.
      '.hs-form-field > label{display:block;margin:0 0 8px;font-family:"Pitch Sans Semibold",ui-monospace,"SF Mono",Menlo,monospace!important;font-size:14px!important;font-weight:600!important;letter-spacing:1.68px!important;text-transform:uppercase!important;color:#767676!important;line-height:1.4}',
      '.hs-form-field > label span{display:inline!important;font-family:inherit!important;font-size:inherit!important;letter-spacing:inherit!important;text-transform:inherit!important}',
      // The required asterisk is hidden. It stays in the DOM so HubSpot's own validation
      // is untouched — Email and Comment are still enforced, just not marked with a *.
      '.hs-form-field > label .hs-form-required,.hs-form-required{display:none!important}',

      '.hs-form-field input[type=text],.hs-form-field input[type=email],.hs-form-field input[type=tel],.hs-form-field textarea,.hs-form-field select{width:100%!important;box-sizing:border-box!important;font-family:"Roobert Regular",Inter,Arial,sans-serif!important;font-size:17px!important;line-height:26px!important;color:#17171a!important;background:#f4f4f0!important;border:1px solid rgba(23,23,26,.1)!important;border-radius:14px!important;padding:14px 16px!important;outline:none}',
      '.hs-form-field input:focus,.hs-form-field textarea:focus,.hs-form-field select:focus{border-color:#cf5c40!important}',
      '.hs-form-field textarea{min-height:150px;resize:vertical}',

      'html body form[class*="hs-form"] .hs-button,html body form[class*="hs-form"] .hs-button:hover,html body form[class*="hs-form"] .hs-button:focus,html body form[class*="hs-form"] .hs-button:active{font-family:Arial,sans-serif!important;font-size:18px!important;color:#fff!important;background:#cf5c40!important;background-color:#cf5c40!important;border:0!important;border-radius:999px!important;padding:14px 32px!important;cursor:pointer}',
      '.hs-error-msg,.hs-error-msgs label{color:#cf5c40!important;font-size:14px!important;font-family:"Roobert Regular",Arial,sans-serif!important;text-transform:none!important;letter-spacing:normal!important}',
      '.submitted-message{font-family:"Roobert Regular",Inter,Arial,sans-serif!important;font-size:17px!important;line-height:26px!important;color:#17171a!important}'
    ].join('\n');
  }

  function drop(doc) {
    DROPPED.forEach(function (name) {
      var el = doc.querySelector('[name="' + name + '"]');
      if (!el || el.disabled) return;
      if (el.tagName === 'SELECT') el.selectedIndex = -1;
      el.value = '';
      el.disabled = true;
    });
  }

  // The page said "Comment" and "Send"; HubSpot says "Message" and "Submit". The
  // required-asterisk span is carried over rather than dropped so HubSpot keeps its
  // own validation hooks; CSS hides it.
  function relabel(doc) {
    var label = doc.querySelector('.hs_TICKET\\.content > label');
    if (label && !/^Comment/.test(label.textContent)) {
      var req = label.querySelector('.hs-form-required');
      label.textContent = 'Comment';
      if (req) label.appendChild(req);
    }
    var btn = doc.querySelector('.hs-button');
    if (btn && btn.value === 'Submit') btn.value = 'Send';
  }

  // HubSpot's per-instance stylesheet (.hs-form-<guid>_<instance> .hs-button) is itself
  // !important and outranks a plain .hs-button, so the button is also set inline.
  function paintButton(doc) {
    var btn = doc.querySelector('.hs-button');
    if (!btn) return;
    var rules = {
      'background-color': '#cf5c40', 'background-image': 'none', 'border': '0',
      'border-radius': '999px', 'color': '#ffffff', 'font-family': 'Arial, sans-serif',
      'font-size': '18px', 'padding': '14px 32px', 'cursor': 'pointer'
    };
    Object.keys(rules).forEach(function (k) { btn.style.setProperty(k, rules[k], 'important'); });
  }

  // HubSpot sizes the iframe once, before the injected CSS has changed anything, so the
  // height is re-synced from the iframe's own content afterwards.
  function keepSized(iframe, doc) {
    function sync() {
      var h = doc.body ? doc.body.scrollHeight : 0;
      if (h) iframe.style.height = h + 'px';
    }
    sync();
    if (typeof ResizeObserver === 'function' && doc.body) {
      new ResizeObserver(sync).observe(doc.body);
    } else {
      setInterval(sync, 500);
    }
    doc.addEventListener('click', function () { setTimeout(sync, 150); }, true);
    setTimeout(sync, 1500);
  }

  function shape(doc) {
    drop(doc);
    relabel(doc);
    paintButton(doc);
  }

  function style(iframe) {
    var doc;
    try { doc = iframe.contentDocument; } catch (error) { return false; }
    if (!doc || !doc.head || !doc.querySelector('.hs-form')) return false;
    if (doc.getElementById('carol-hs-style')) return true;
    var el = doc.createElement('style');
    el.id = 'carol-hs-style';
    el.textContent = css();
    doc.head.appendChild(el);
    shape(doc);
    if (typeof MutationObserver === 'function' && doc.body) {
      new MutationObserver(function () { shape(doc); }).observe(doc.body, { childList: true, subtree: true });
    }
    keepSized(iframe, doc);
    return true;
  }

  function watch() {
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var iframe = host.querySelector('iframe');
      if (iframe && style(iframe)) { clearInterval(timer); return; }
      if (tries > 60) clearInterval(timer); // ~12s; the form still works unstyled.
    }, 200);
  }

  function create() {
    window.hbspt.forms.create({ portalId: PORTAL, formId: GUID, region: REGION, target: TARGET });
    watch();
  }

  if (window.hbspt && window.hbspt.forms) return create();
  var s = document.createElement('script');
  s.src = 'https://js.hsforms.net/forms/embed/v2.js';
  s.charset = 'utf-8';
  s.async = true;
  s.onload = create;
  s.onerror = function () { console.warn('[carol-contact] HubSpot embed script failed to load.'); };
  document.head.appendChild(s);
})();
